import { PathwayLaunchDarklyWebAlertBanner } from '@/types';

export const normalizeWebAlertBanners = (
  webAlertBanner:
    | PathwayLaunchDarklyWebAlertBanner
    | PathwayLaunchDarklyWebAlertBanner[]
    | undefined,
): PathwayLaunchDarklyWebAlertBanner[] => {
  const list = Array.isArray(webAlertBanner)
    ? webAlertBanner
    : webAlertBanner
      ? [webAlertBanner]
      : [];

  return list.map(b => {
    if (b.id) return b;
    const raw = `${b.startDate}|${b.endDate}|${JSON.stringify(b.message)}|${b.link?.url ?? ''}`;
    const bytes = new TextEncoder().encode(raw);
    const id = btoa(String.fromCodePoint(...bytes)).replace(/=+$/, '');
    return { ...b, id };
  });
};

interface BannerContext {
  isLeaderOrOperator: boolean;
  hasComplianceEnabled: boolean;
  hasXpCompliancePlans: boolean;
  isInCompliancePhaseSegment: boolean;
  isInChainWideRollout: boolean;
}

const matchesBannerCriteria = (
  b: PathwayLaunchDarklyWebAlertBanner,
  ctx: BannerContext,
): boolean => {
  if (b.alertType === 'CompliancePlanCompletionNoticePhased') {
    return (
      ctx.hasComplianceEnabled &&
      !ctx.hasXpCompliancePlans &&
      ctx.isInCompliancePhaseSegment
    );
  }
  if (b.alertType === 'CompliancePlanCompletionNoticeChainWide') {
    return (
      ctx.hasComplianceEnabled &&
      !ctx.hasXpCompliancePlans &&
      ctx.isInChainWideRollout
    );
  }
  return ctx.isLeaderOrOperator;
};

export const computeBannersToShow = (
  webAlertBanner:
    | PathwayLaunchDarklyWebAlertBanner
    | PathwayLaunchDarklyWebAlertBanner[]
    | undefined,
  dismissedIds: string[],
  ctx: BannerContext,
  now: number = Math.floor(Date.now() / 1000),
): PathwayLaunchDarklyWebAlertBanner[] => {
  const normalized = normalizeWebAlertBanners(webAlertBanner);
  return normalized.filter(b => {
    if (!b.id) return false;
    const inDateRange = now >= b.startDate && now <= b.endDate;
    const dismissed = dismissedIds.includes(b.id);
    return (
      b.status && !dismissed && inDateRange && matchesBannerCriteria(b, ctx)
    );
  });
};
